import {
  GET_PRODUCTS,
  GET_VITRIN_PRODUCTS,
  GET_PRODUCT,
  UPDATE_PRODUCTS,
  CREATE_PRODUCTS,
  GET_PRODUCTS_INVONTORY,
  GET_ALL_PRODUCTS,
  GET_PRODUCT_VARIANTS,
  GET_VARIANT,
  GET_CATEGORIES,
  GET_PRODUCT_VARIANT_INVENTORY_ITEMS,
  GET_PARTNER_CATEGORIES,
  CLEAR_PRODUCT,
  DELETE_VARIANT,
} from './constants';
import {PayloadUpdate, PayloadCreate, PayloadInventory} from './interfaces';

export function getProductsAction(payload: Record<string, any>) {
  return {
    type: GET_PRODUCTS,
    payload,
  };
}
export function getVitrinProductsAction(payload: Record<string, any>) {
  return {
    type: GET_VITRIN_PRODUCTS,
    payload,
  };
}

export function getCategoriesAction(payload: Record<string, any>) {
  return {
    type: GET_CATEGORIES,
    payload,
  };
}

export function getProductAction(payload: Record<string, any>) {
  return {
    type: GET_PRODUCT,
    payload,
  };
}

export function getVariantAction(payload: Record<string, any>) {
  return {
    type: GET_VARIANT,
    payload,
  };
}
export function deleteVariantAction(payload: Record<string, any>) {
  return {
    type: DELETE_VARIANT,
    payload,
  };
}

export function getAllProductsAction(payload: Record<string, any>) {
  return {
    type: GET_ALL_PRODUCTS,
    payload,
  };
}

export function updateProductActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_PRODUCTS,
    payload,
  };
}

export function createProductsActions(payload: PayloadCreate) {
  return {
    type: CREATE_PRODUCTS,
    payload,
  };
}

export function getProductsInventoryActions(payload: PayloadInventory) {
  return {
    type: GET_PRODUCTS_INVONTORY,
    payload,
  };
}

export function getProductVariantsActions(payload: Record<string, any>) {
  return {
    type: GET_PRODUCT_VARIANTS,
    payload,
  };
}

export function getVariantInventoryItemsAction(payload: PayloadInventory) {
  return {
    type: GET_PRODUCT_VARIANT_INVENTORY_ITEMS,
    payload,
  };
}

export function getPartnerCategoriesAction(payload: Object) {
  return {
    type: GET_PARTNER_CATEGORIES,
    payload,
  };
}

export function clearProductAction() {
  return {
    type: CLEAR_PRODUCT,
  };
}
